import { isTruthyAndNotEmpty } from '@stimcar/libs-kernel';

const SLUG_PATTERN = /^[a-z][a-z0-9]*(-[a-z0-9]+)*$/;

/**
 * Turns a free-form app name into a kebab-case scratch-app slug.
 * Empty / invalid input yields `undefined`.
 */
export function slugifyScratchAppName(raw: string): string | undefined {
  const normalized = raw
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
  if (!isTruthyAndNotEmpty(normalized)) {
    return undefined;
  }
  const withLetterPrefix = /^[a-z]/.test(normalized) ? normalized : `app-${normalized}`;
  if (!SLUG_PATTERN.test(withLetterPrefix)) {
    return undefined;
  }
  return withLetterPrefix;
}

export function isValidScratchAppSlug(slug: string): boolean {
  return SLUG_PATTERN.test(slug);
}
